import styled from 'styled-components';

import { Text } from '@gympass/yoga';

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.yoga.spacing.zero};
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
`;

export const StyledRow = styled.div`
  overflow: hidden;
  text-align: center;
`;

export const SectionContainer = styled.div`
  margin: ${({ theme }) => theme.yoga.spacing.xxsmall}px auto;
  max-width: 400px;
  padding: ${({ theme }) => theme.yoga.spacing.zero}
    ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const Description = styled(Text)`
  margin: ${({ theme }) => theme.yoga.spacing.zero};
  white-space: pre-line;
  color: var(--text-primary);
  font-size: ${({ theme }) => theme.yoga.fontSizes.large}px;
`;

export const Image = styled.img`
  height: 122px;
  color: var(--primary);
  margin: ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.zero};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: ${({ theme }) => theme.yoga.spacing.medium}px;
  background-color: var(--background-light);
`;
